/** Keep locale digits/grouping while using a dot for every decimal display. */
export function createDisplayNumberFormat(locales?: Intl.LocalesArgument, options?: Intl.NumberFormatOptions): Intl.NumberFormat {
  const formatter = new Intl.NumberFormat(locales, options);
  const parts = formatter.formatToParts.bind(formatter);
  Object.defineProperty(formatter, 'format', {
    value: (value: number | bigint) => parts(value).map(part => part.type === 'decimal' ? '.' : part.value).join(''),
  });
  return formatter;
}
